import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=18dea0dd&scoped=true"
import script from "./Hero.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Hero.vue?vue&type=style&index=0&id=18dea0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dea0dd",
  null
  
)

export default component.exports